import React from "react";

const Alert = ({ show, message, type, onClose }) => {
  const baseAlertClasses = [
    `flex justify-between items-center centered-x w-fit z-50 border px-4 py-3 rounded-xl`,
  ];

  // Toggle classes
  if (show) baseAlertClasses.push(`opacity-1000`);
  else baseAlertClasses.push(`opacity-0`);

  // Theme classes
  if (type === "error") {
    baseAlertClasses.push(
      "bg-red-100 border-red-400 dark:bg-red-500 dark:border-red-500 "
    );
  } else if (type === "success") {
    baseAlertClasses.push(
      "bg-green-100 text-green-400 border-green-400 dark:bg-green-500 dark:border-green-500 "
    );
  }

  return (
    <div className={baseAlertClasses.join(" ")} role="alert">
      <p className="font-bold">{message}</p>
      <span onClick={onClose} className="ml-4 ">
        <svg
          className="fill-current h-6 w-6"
          role="button"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <title>Close</title>
          <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
        </svg>
      </span>
    </div>
  );
};

export default Alert;
